import ContactListItem from 'components/Contacts/ContactListItem';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ReactInfinite from 'react-infinite';
import ReactDOM from 'react-dom';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import dropdownNavigation from 'components/Dropdown/DropdownNavigation';
import classes from './FavoritesSearch.module.scss';

const ELEMENT_HEIGHT = 40;

class FavoritesSearchResults extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.selectionIndex > this.props.selectionIndex) {
      this.scrollToNextResult();
    }

    if (nextProps.selectionIndex < this.props.selectionIndex) {
      this.scrollToPreviousResult();
    }
  }

  /* eslint-disable react/no-find-dom-node */
  getScrollTop = () => ReactDOM.findDOMNode(this).scrollTop;

  setScrollTop = (scrollTop) => {
    ReactDOM.findDOMNode(this).scrollTop = scrollTop;
  };
  /* eslint-enable react/no-find-dom-node */

  scrollToNextResult = () => {
    const highlightedIndex = this.props.selectionIndex + 2;
    if (highlightedIndex * ELEMENT_HEIGHT > this.getScrollTop() + this.props.maxItems * ELEMENT_HEIGHT) {
      this.setScrollTop((highlightedIndex - this.props.maxItems) * ELEMENT_HEIGHT);
    }
  };

  scrollToPreviousResult = () => {
    const highlightedIndex = this.props.selectionIndex - 1;
    if (highlightedIndex * ELEMENT_HEIGHT < this.getScrollTop()) {
      this.setScrollTop(highlightedIndex * ELEMENT_HEIGHT);
    }
  };

  render() {
    const { searchResults, handleSelectContact, maxItems, searchString, selectionIndex } = this.props;
    let returnArray = [];
    const emptyState = searchString && searchString.length && !searchResults.length;
    if (emptyState) {
      returnArray = <EmptyMessage />;
    } else {
      returnArray = searchResults.map((result, index) => (
        <ContactListItem
          key={result.contact.id}
          className={classes.contactListItem}
          contact={result.contact}
          matches={result.matches.name}
          handleSelectContact={handleSelectContact}
          isHighlighted={index === selectionIndex}
          nameFontSize={'14px'}
          noButtons
          presenceStyle={{
            height: '12px',
            width: '12px',
            right: '-5px',
            bottom: '-3px',
            border: '2px solid #ffffff'
          }}
          dataTestTag="favSearch-contact"
        />
      ));
    }

    return (
      <ReactInfinite
        className={classes.infiniteScroll}
        containerHeight={maxItems * ELEMENT_HEIGHT}
        elementHeight={ELEMENT_HEIGHT}
        styles={
          emptyState
            ? { scrollableStyle: { overflowY: 'auto', height: 'auto' } }
            : { scrollableStyle: { overflowY: 'auto' } }
        }
      >
        {returnArray}
      </ReactInfinite>
    );
  }
}

FavoritesSearchResults.propTypes = {
  searchString: PT.string,
  searchResults: PT.array,
  handleSelectContact: PT.func,
  maxItems: PT.number,
  selectionIndex: PT.number
};

export default dropdownNavigation(FavoritesSearchResults);
